import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  filteredBy: [],
};

const projectsSlice = createSlice({
  name: "projects",
  initialState,
  reducers: {
    filteredByProjects: (state, action) => {
      if (!state.filteredBy.includes(action.payload)) {
        state.filteredBy.push(action.payload);
      }
    },
    resetFilters: (state, action) => {
      const findIndexToRemove = state.filteredBy.indexOf(action.payload);
      state.filteredBy.splice(findIndexToRemove, 1);
    },
  },
});

export const { filteredByProjects, resetFilters } = projectsSlice.actions;
export default projectsSlice.reducer;
